import { useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Input } from "@/components/ui/input";
import { PageShell } from "@/components/site/Site";
import { useContent } from "@/lib/api";

export default function Faq() {
  const { data } = useContent();
  const [q, setQ] = useState("");
  const faqs = (data?.faqs || []).filter((f) => (f.q + f.a).toLowerCase().includes(q.toLowerCase()));
  return (
    <PageShell>
      <section className="mx-auto max-w-3xl px-5 py-20 sm:px-8">
        <h1 className="font-serif-display text-4xl sm:text-5xl">Frequently Asked Questions</h1>
        <Input placeholder="Search questions…" value={q} onChange={(e) => setQ(e.target.value)} className="mt-10 h-12 bg-white" data-testid="faq-search-input" />
        <Accordion type="single" collapsible className="mt-8" data-testid="faq-list">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`q${i}`} className="border-[#E6DEC8]">
              <AccordionTrigger className="text-left text-base hover:no-underline" data-testid={`faq-item-${i}`}>{f.q}</AccordionTrigger>
              <AccordionContent className="text-stone-600">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        {!faqs.length && <p className="mt-8 text-stone-500" data-testid="faq-empty">No matching questions.</p>}
      </section>
    </PageShell>
  );
}
